/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCBulkAttributeModal = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
      <Dialog open={showBulkAttributeModal} onOpenChange={setShowBulkAttributeModal}>
        <DialogContent className="max-w-lg" data-testid="credits-bulk-attribute-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Gift className="w-5 h-5 text-blue-600" />
              Attribuer des crédits en masse
            </DialogTitle>
            <DialogDescription>
              {selectedUserIds.size} utilisateur(s) sélectionné(s)
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Crédits *</Label>
                <Input
                  type="number"
                  value={bulkAttributeForm.credits}
                  onChange={(e) => setBulkAttributeForm({ ...bulkAttributeForm, credits: parseInt(e.target.value || '0', 10) })}
                  data-testid="credits-bulk-credits-input"
                />
              </div>
              <div>
                <Label>Type</Label>
                <Select
                  value={bulkAttributeForm.type_credit}
                  onValueChange={(v) => setBulkAttributeForm({ ...bulkAttributeForm, type_credit: v })}
                >
                  <SelectTrigger data-testid="credits-bulk-type-select"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="STANDARD">Standard</SelectItem>
                    <SelectItem value="PRIORITY">Prioritaire</SelectItem>
                    <SelectItem value="BONUS">Bonus</SelectItem>
                    <SelectItem value="TEMPORARY">Temporaire</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            {bulkAttributeForm.type_credit === 'TEMPORARY' && (
              <div>
                <Label>Durée de validité (jours)</Label>
                <Input
                  type="number"
                  value={bulkAttributeForm.duree_validite_jours || ''}
                  onChange={(e) => setBulkAttributeForm({ ...bulkAttributeForm, duree_validite_jours: e.target.value ? parseInt(e.target.value, 10) : null })}
                  data-testid="credits-bulk-duree"
                />
              </div>
            )}
            <div>
              <Label>Raison *</Label>
              <Textarea
                value={bulkAttributeForm.raison}
                onChange={(e) => setBulkAttributeForm({ ...bulkAttributeForm, raison: e.target.value })}
                placeholder="Motif de l'attribution (audit log)…"
                data-testid="credits-bulk-raison"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowBulkAttributeModal(false)}>Annuler</Button>
            <Button onClick={handleBulkAttribute} className="bg-blue-600 hover:bg-blue-700" data-testid="credits-bulk-confirm">
              <Gift className="w-4 h-4 mr-2" />
              Attribuer {bulkAttributeForm.credits} crédits à {selectedUserIds.size} utilisateur(s)
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default GCBulkAttributeModal;
